import { slice } from './slice';

const { reducer } = slice;

export * from './types';
export * as loyaltyTasksSelectors from './selectors';

export default reducer;
